<div class="layout-sidebar">
  <p-scrollPanel #layoutMenuScroller [style]="{ height: '100%' }">
    <div class="menu-scroll-content">
      <ul
        app-submenu
        [item]="menuItems"
        [root]="true"
        class="layout-menu"
        [visible]="true"
        [reset]="reset()"
        [parentActive]="parentActive()"
      ></ul>
    </div>
  </p-scrollPanel>
  <span
    id="version"
    [translate]="'COMMON.LABEL.VERSION'"
    [translateParams]="{ value: version() }"
  ></span>
</div>
